import * as S from './CaptchaFrame.style';

export const CAPTCHA_FRAME_ID = 'captcha-placeholder';

const CaptchaFrame = () => {
  return <S.CaptchaContainer id={CAPTCHA_FRAME_ID} />;
};

export default CaptchaFrame;
